<template>
    <div class="item-block" :class="labelPosition">
        <div class="label" :style="{ width: `${labelWidth}px`, color: `${labelColor}` }" :class="labelPosition">
            <template v-if="hasLabelSlot">
                <slot name="label"></slot>
            </template>
            <template v-else>{{ label }}</template>
            <ahTip v-if="tip">{{ tip }}</ahTip>
        </div>

        <div class="content" :class="labelPosition">
            <slot />
        </div>
    </div>
</template>
<script>
export default {
    props: {
        label: {
            type: String,
            default: '',
        },
        tip: {
            type: String,
            default: null,
        },
        labelPosition: {
            type: String,
            default: 'left',
        },
        labelWidth: {
            type: [Number, String],
            default: 100,
        },
        labelColor: {
            type: String,
            default: '#00000080',
        },
    },
    computed: {
        hasLabelSlot() {
            return !!this.$slots.label;
        },
    },
};
</script>

<style lang="scss" scoped>
.item-block {
    display: flex;
    &.top {
        flex-direction: column;
    }
    &.right {
        flex-direction: row-reverse;
    }
    .label {
        padding: 2px 0;
        &.top {
            padding-bottom: 0;
        }
    }
    .content {
        padding: 2px 0 0;
        margin-bottom: 5px;
        line-height: 18px;
        &.top {
            padding-top: 0;
        }
        &.right {
            padding-right: 10px;
        }
    }
}
</style>
